<div class="w-100 h-100 overflow-hidden">
  <div class="loading-container position-absolute bg-white">
    <div class="d-flex flex-column align-items-center p-3">
      <h2 class="text-sm">Redirecting...</h2>
      <hr />
      <div class="text-xs">
        <p class="m-0">
          This page will be automatically reloaded. Please wait...
        </p>
        <p class="m-0">
          Do not navigate <strong>Back</strong> and <strong>Reload</strong> this
          page.
        </p>
      </div>
    </div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
